<app-partner-portal-breadcrumbs [(breadcrumbs)]="breadcrumbs"></app-partner-portal-breadcrumbs>

<app-partner-user-info-address #infoform>
  <div class="col-12 px-0 py-3 d-flex justify-content-start">
    <button class="btn btn-lg btn-success" (click)="saveForm(infoform)" [disabled]="!infoform.formValid">
      {{ "SAVE" | translate }}
    </button>
  </div>
</app-partner-user-info-address>
